/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const SnappingIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 43 43"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-1755,-615)">
      <g id="Snapping" transform="matrix(0.641901,0,0,0.642039,-292.586,533.519)">
        <g transform="matrix(0.545713,-2.33866e-16,-8.68715e-17,0.545713,1840.69,126.906)">
          <g id="backing">
            <path
              d="M2594.75,19.846L2594.75,102.555C2594.75,113.508 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.508 2472.35,102.555L2472.35,19.846C2472.35,8.893 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.893 2594.75,19.846Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(1.18457,-0.683766,0.684059,1.18457,-707.452,2180.46)">
          <g transform="matrix(1.55787,0,0,1.55754,-140.183,-1408.97)">
            <path
              d="M2148.84,1003.8L2148.82,1003.8C2148.82,996.912 2154.41,991.322 2161.29,991.322C2168.18,991.322 2173.77,996.912 2173.77,1003.8L2173.76,1003.8L2173.76,1008.46L2170.84,1008.46L2170.84,1003.59L2170.85,1003.59C2170.74,998.409 2166.5,994.238 2161.29,994.238C2156.09,994.238 2151.85,998.409 2151.74,1003.59L2151.75,1003.59L2151.75,1008.46L2148.84,1008.46L2148.84,1003.8Z"
              style={{ fill: 'white' }}
            />
          </g>
          <g transform="matrix(2.14203,-1.11022e-16,0,1.48868,-1406.18,-1343.64)">
            <path
              d="M2167.66,1020.04L2158.18,1020.04L2162.92,1002.91L2167.66,1020.04ZM2162.92,1011.16L2161.31,1016.99C2161.31,1016.99 2164.53,1016.99 2164.53,1016.99L2162.92,1011.16Z"
              style={{ fill: 'white' }}
            />
          </g>
          <g transform="matrix(1,0,0,1,0.0300101,-3.11508)">
            <g transform="matrix(1.55787,0,0,0.247178,-189.585,-79.6917)">
              <rect x="2180.52" y="1006.18" width="2.917" height="19.104" style={{ fill: 'white' }} />
            </g>
            <g transform="matrix(1.55787,0,0,0.247178,-155.301,-79.6917)">
              <rect x="2180.52" y="1006.18" width="2.917" height="19.104" style={{ fill: 'white' }} />
            </g>
          </g>
          <g transform="matrix(1.55787,0,0,0.451261,-172.394,-281.501)">
            <rect x="2180.52" y="1006.18" width="2.917" height="19.104" style={{ fill: 'white' }} />
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'SnappingIcon',
);
